




import { Component, Vue } from 'vue-property-decorator'
  @Component({
  })

export default class Logo extends Vue {
  public get color (): string {
    const colors: Array<string> = ['#ebedf0', '#c6e48b', '#7bc96f', '#239a3b', '#196127']
    return colors[Math.floor(Math.random() * colors.length)]
  }
}
